module.exports = __webpack_public_path__ + "static/media/vehicle.9b2d5db2.svg";